import React from 'react';
import './Services.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  Monitor,
  Smartphone,
  Cloud,
  Wrench,
  Palette,
  BarChart3,
  Hotel,
  Receipt,
  Building2,
  BriefcaseBusiness,
  ArrowRight,
} from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Monitor,
      title: 'Web Development',
      description: 'Custom web applications built with modern technologies like React, Node.js, and cloud platforms.',
      features: ['Responsive Design', 'SEO Optimization', 'Performance Tuning', 'Security Implementation'],
      path: '/web-development',
    },
    {
      icon: Smartphone,
      title: 'Mobile App Development',
      description: 'Native and cross-platform mobile applications for iOS and Android devices.',
      features: ['iOS Development', 'Android Development', 'React Native', 'Flutter Apps'],
      path: '/mobile-app',
    },
    {
      icon: Cloud,
      title: 'Cloud Solutions',
      description: 'Scalable cloud infrastructure and migration services for modern businesses.',
      features: ['AWS Services', 'Azure Solutions', 'Google Cloud', 'DevOps Implementation'],
      path: '/cloud-solutions',
    },
    {
      icon: Wrench,
      title: 'IT Support & Maintenance',
      description: 'Comprehensive IT support services to keep your systems running smoothly.',
      features: ['24/7 Support', 'System Monitoring', 'Backup Solutions', 'Security Updates'],
      path: '/it-support',
    },
    {
      icon: Palette,
      title: 'UI/UX Design',
      description: 'User-centered design solutions that enhance user experience and engagement.',
      features: ['User Research', 'Wireframing', 'Prototyping', 'Design Systems'],
      path: '/ui-ux',
    },
    {
      icon: BarChart3,
      title: 'Data Analytics',
      description: 'Transform your data into actionable insights with our analytics solutions.',
      features: ['Data Visualization', 'Business Intelligence', 'Machine Learning', 'Reporting Dashboards'],
      path: '/data-analytics',
    },
    {
      icon: Hotel,
      title: 'Hostel Management Software',
      description: 'Smart hostel operations platform for admissions, room allocation, fees, and attendance.',
      features: ['Room & Bed Allocation', 'Student Records', 'Fee Collection', 'Visitor Tracking'],
      path: '/contact',
    },
    {
      icon: Receipt,
      title: 'POS Billing Software',
      description: 'Retail and restaurant POS software with billing, inventory, and payment integrations.',
      features: ['Fast Billing', 'Inventory Sync', 'GST Invoices', 'Sales Reports'],
      path: '/contact',
    },
    {
      icon: Building2,
      title: 'ERP & CRM Systems',
      description: 'Integrated ERP and CRM solutions to manage operations, sales, and customer lifecycle.',
      features: ['Lead Management', 'Workflow Automation', 'Finance Modules', 'Customer Support'],
      path: '/contact',
    },
    {
      icon: BriefcaseBusiness,
      title: 'Custom Management Systems',
      description: 'Tailored software for schools, hospitals, logistics, and enterprise process management.',
      features: ['Role-based Access', 'Approvals & Workflows', 'MIS Dashboards', 'Cloud Deployment'],
      path: '/contact',
    },
  ];

  return (
    <div className="services">
      <div className="services-hero">
        <div className="hero-pattern" />
        <div className="container">
          <motion.h1
            className="services-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Our Services
          </motion.h1>
          <motion.p
            className="services-subtitle"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Comprehensive IT solutions tailored to meet your business needs and drive growth
          </motion.p>
        </div>
      </div>

      <section className="services-grid section">
        <div className="container">
          <div className="services-container">
            {services.map((service, index) => (
              <motion.div
                key={index}
                className="service-card"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-30px' }}
                transition={{ duration: 0.4, delay: index * 0.06 }}
                whileHover={{ y: -6, transition: { duration: 0.2 } }}
              >
                <div className="service-icon-wrap">
                  <service.icon size={28} strokeWidth={1.8} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
                <Link to={service.path} className="service-btn">
                  Learn More
                  <ArrowRight size={18} />
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
